import "./scss/index.scss";
import "./js/index";

import "./images/logo.png";
/*
import './images/logo.png';
import './images/logo-2x.png';


import './images/1.jpg';
import "./images/2.jpg";
import "./images/3.jpg";
import "./images/4.jpg";
import "./images/5.jpg";
import "./images/6.jpg";
import "./images/7.jpg";
import './images/m_1.jpg';
import "./images/m_2.jpg";
import "./images/m_3.jpg";
import "./images/m_4.jpg";
import "./images/m_5.jpg";
import "./images/m_6.jpg";
import "./images/m_7.jpg";
*/
